var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 163.6 163.7",
    style: {
      enableBackground: "new 0 0 163.6 163.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.8,94c0,10.2,0,20.3,0,30.5c0,1.1-0.3,1.5-1.4,1.5c-5.8-0.1-11.5,0-17.3,0c-0.9,0-1.2-0.2-1.2-1.2 c0-20.6,0-41.1,0-61.7c0-0.9,0.2-1.2,1.1-1.1c5.9,0,11.7,0,17.6,0c1.1,0,1.3,0.4,1.3,1.4C55.8,73.5,55.8,83.7,55.8,94 M57.4,41.5 c0,6.4-5.2,11.6-11.5,11.6c-6.3,0-11.5-5.2-11.5-11.5c0-6.3,5.2-11.6,11.5-11.6C52.2,30,57.4,35.2,57.4,41.5z M87.4,70.5 c1.3-1.5,2.4-3,3.8-4.3c4.2-4,9.2-6,15-5.9c3.2,0,6.4,0.3,9.4,1.1c7,2,11.1,6.9,13.1,13.8c1.5,5.2,1.7,10.4,1.7,15.8 c0,11.2,0,22.4,0,33.6c0,1-0.3,1.3-1.3,1.3c-5.8,0-11.5,0-17.3,0c-1,0-1.2-0.3-1.2-1.3c0-10.7,0-21.3,0-32c0-2.7-0.2-5.3-0.9-7.9 c-1.4-4.8-4.8-7.2-9.8-7c-6.8,0.4-10.4,3.7-11.3,10.7c-0.2,1.7-0.3,3.3-0.3,5c0,10.4,0,20.7,0,31.1c0,1-0.3,1.3-1.3,1.3 c-5.8-0.1-11.6,0-17.4,0c-0.9,0-1.2-0.2-1.2-1.2c0-20.5,0-41,0-61.6c0-1,0.3-1.3,1.3-1.2c5.5,0,11,0,16.6,0c1,0,1.3,0.3,1.3,1.3 C87.4,65.6,87.4,68.1,87.4,70.5z M80.8,2c44.6,0,80.8,36.2,80.8,80.9s-36.2,80.9-80.8,80.9C36.2,163.7,0,127.5,0,82.9S36.2,2,80.8,2 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c7ae9a87325def18c8564e9f2699d909.svg";
export { ForwardRef as ReactComponent };